import React from "react";
import "./item_table.scss";

const titles = [
    "Item",
    "Material",
    "Description",
    "Net Price",
    "Currency",
    "Cancelled",
    "Target Quantity",
    "Open Target Quantity"
];

const VoaItemTable = ({ items, className }) => {
    const rows =
        items &&
        Object.values(items).map((item, index) => {
            return (
                <tr key={`item_value_${index}`} style={{ textAlign: "center" }}>
                    <td>{item.item}</td>
                    <td>{item.material}</td>
                    <td>{item.description}</td>
                    <td>{item.net_price}</td>
                    <td>{item.currency}</td>
                    <td>{item.currency ? "Active" : "Cancelled"}</td>
                    <td>{item.target_quantity}</td>
                    <td>{item.open_target_quantity}</td>
                </tr>
            );
        });

    return (
        <div {...{ className }}>
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`item_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            </div>
        </div>
    );
};

VoaItemTable.header = (
    <nav className="navbar">
        <span className="navbar-brand h4">CPO Items Level.</span>
    </nav>
);

export default VoaItemTable;
